import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

console.log('[MAIN] ========== React Initializing ==========');
console.log('[MAIN] Current window.location.href:', window.location.href);
console.log('[MAIN] Current window.location.pathname:', window.location.pathname);
console.log('[MAIN] Current window.location.search:', window.location.search);
console.log('[MAIN] Current window.location.hostname:', window.location.hostname);
console.log('[MAIN] Document ready state:', document.readyState);
console.log('[MAIN] User agent:', navigator.userAgent);

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error('[MAIN] Root element not found!');
} else {
  console.log('[MAIN] Root element found, rendering App...');
  createRoot(rootElement).render(<App />);
  console.log('[MAIN] App rendered successfully');
}
